// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"staff-pick-badge_shadow__1Pk7F","badge":"staff-pick-badge_badge__UTHO-","link":"staff-pick-badge_link__1wtFs"};